import ChargeValidity from "entities/chargeValidity";
import {
  vignetteOneDay,
  vignetteOneDayShadow,
  vignette10Days,
  vignette10DaysShadow,
  vignetteAnnual,
  vignetteAnnualShadow,
  vignetteMonth,
  vignetteMonthShadow,
} from "./vignetteAssets";
import {
  vignetteOneDayEN,
  vignetteOneDayENShadow,
  vignette10DaysEN,
  vignette10DaysENShadow,
  vignetteAnnualEN,
  vignetteAnnualENShadow,
  vignetteMonthEN,
  vignetteMonthENShadow,
} from "./vignetteAssetsEN";

export const chargeTypeIconWithShadow = (validFor: ChargeValidity, isCSLocale: boolean) => {
  switch (validFor) {
    case ChargeValidity.Annual:
      return isCSLocale ? vignetteAnnualShadow : vignetteAnnualENShadow;
    case ChargeValidity.Days30:
      return isCSLocale ? vignetteMonthShadow : vignetteMonthENShadow;
    case ChargeValidity.Days10:
      return isCSLocale ? vignette10DaysShadow : vignette10DaysENShadow;
    case ChargeValidity.SingleDay:
      return isCSLocale ? vignetteOneDayShadow : vignetteOneDayENShadow;
  }
};

export const chargeTypeIcon = (validFor: ChargeValidity, isCSLocale: boolean) => {
  switch (validFor) {
    case ChargeValidity.Annual:
      return isCSLocale ? vignetteAnnual : vignetteAnnualEN;
    case ChargeValidity.Days30:
      return isCSLocale ? vignetteMonth : vignetteMonthEN;
    case ChargeValidity.Days10:
      return isCSLocale ? vignette10Days : vignette10DaysEN;
    case ChargeValidity.SingleDay:
      return isCSLocale ? vignetteOneDay : vignetteOneDayEN;
  }
};
